import { takeEvery, call } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { massAssignProductsApi, ChannelNS, channelSlice } from 'Pages/orders'

function* sendMassAssign(action: ChannelNS.SendMassAssignProduct) {
	try {
		yield* call(massAssignProductsApi.sendMassAssignRequestApi, action.payload)
		yield* call(notifyMessageCreator, 'orders.mass_assign.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const massAssignProductSaga = function* saga() {
	yield* takeEvery(channelSlice.actions.sendMassAssignProduct.type, sendMassAssign)
}
